import { useTranslation } from 'react-i18next';
import { MarketButton } from '@market/react';
import { HTMLAttributes } from 'react';

interface SubmitButtonProps extends HTMLAttributes<HTMLElement> {
  disabled?: boolean;
  buttonCTA?: string;
  tokenize?: () => Promise<void>;
  onClick?: () => Promise<void>;
}

const SubmitButton = ({
  disabled = false,
  buttonCTA,
  tokenize,
  onClick,
  className,
}: SubmitButtonProps) => {
  const { t } = useTranslation();

  const submitAction = async () => {
    if (tokenize) {
      await tokenize();
    }
  };

  return (
    <MarketButton
      className={className}
      disabled={disabled}
      id="payment-submit-btn"
      rank="primary"
      onClick={async () => {
        onClick ? await onClick() : await submitAction();
      }}
      style={{ width: '100%' }}
    >
      {buttonCTA || String(t('common.submit'))}
    </MarketButton>
  );
};

export default SubmitButton;
